// import classes
import { switchClasses } from "@mui/material/Switch";
import { DOUBLE, QUINDECUPLE } from "../../../constants/numbers.consts.js";
const OFFSET = 50;
const BORDER_RADIUS = 24;
export default {
    styleOverrides: {
        root: ({ theme }) => ({
            borderRadius: `${BORDER_RADIUS}px`,
            padding: 0,
            width: 52,
            height: 29,
            boxShadow: `0 0 0 ${DOUBLE}px ${theme.vars.palette.surface.onVariant}`,
            backgroundColor: theme.vars.palette.surface.variant,
            [`&:has(.${switchClasses.checked})`]: {
                boxShadow: "none",
                width: 52,
                height: 32,
                backgroundColor: theme.vars.palette.primary.main,
            },
        }),
        switchBase: ({ theme }) => ({
            top: `${OFFSET}%`,
            transform: `translateY(-${OFFSET}%)`,
            [`&.${switchClasses.checked}`]: {
                transform: `translateX(${QUINDECUPLE}px) translateY(-${OFFSET}%)`,
                [`& .${switchClasses.thumb}`]: {
                    backgroundColor: theme.vars.palette.common.white,
                    width: 24,
                    height: 24,
                },
            },
            [`&.Mui-focusVisible.${switchClasses.thumb}`]: {
                color: theme.vars.palette.surface.onVariant,
            },
        }),
        thumb: ({ theme }) => ({
            backgroundColor: theme.vars.palette.surface.onVariant,
            width: 16,
            height: 16,
        }),
        track: ({ theme }) => ({
            backgroundColor: theme.vars.palette.surface.variant,
        }),
    },
};
